// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-k575CE"};